/**
 * Order Detail Drawer — Dettaglio ordine dal profilo.
 *
 * Apre un drawer laterale (da destra) con tutte le info dell'ordine:
 * stato, prodotti, riepilogo importi, dati fatturazione, metodo pagamento, fatture.
 *
 * Uso nel template:
 *   <div x-data="orderDetail">
 *     <button @click="open(123, invoicesJson)">Dettaglio</button>
 *   </div>
 */
export function registerOrderDetail(Alpine) {
    Alpine.data('orderDetail', () => ({
        drawerOpen: false,
        loading: false,
        error: '',
        order: null,
        invoices: [],   // fatture associate (passate dalla view SSR)

        open(orderId, invoices) {
            if (this.loading) return;
            this.invoices = invoices || [];
            this.drawerOpen = true;
            document.body.style.overflow = 'hidden';
            this._fetchOrder(orderId);
        },

        close() {
            this.drawerOpen = false;
            this.order = null;
            this.error = '';
            document.body.style.overflow = '';
        },

        async _fetchOrder(orderId) {
            this.loading = true;
            this.error = '';
            this.order = null;

            try {
                const res = await fetch(
                    `${window.IKOS.apiBase}/v1/users/me/orders/${orderId}`,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Auth-Token': window.IKOS.authToken,
                        },
                    }
                );
                if (!res.ok) {
                    this.error = 'Impossibile caricare l\'ordine.';
                    return;
                }
                this.order = await res.json();
            } catch (e) {
                this.error = 'Errore di connessione. Riprova.';
            } finally {
                this.loading = false;
            }
        },

        /** Stato → classe CSS per badge colorato */
        statusClass() {
            if (!this.order) return '';
            const s = (this.order.status || '').toLowerCase();
            if (['annullato', 'cancellato', 'rifiutato'].includes(s)) return 'ik-profile-orders-status--cancelled';
            if (this.order.payment_required) return 'ik-profile-orders-status--pending';
            return 'ik-profile-orders-status--completed';
        },

        /** Formatta data Y-m-d → dd/mm/yyyy */
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [y, m, d] = dateStr.split('-');
            return `${d}/${m}/${y}`;
        },
    }));
}
